"use client";

import { useAdContext } from "./AdContextProvider";
import { AdSlot } from "./AdSlot";

/**
 * Above-footer ad slot wrapped in a site-width container.
 * Returns null entirely when no ad is configured (no empty wrapper/margin).
 */
export function AboveFooterSlot() {
    const adContext = useAdContext();
    if (!adContext?.slots["above-footer"]) return null;

    return (
        <div className="max-w-350 mx-auto px-4 my-8">
            <AdSlot id="above-footer" />
        </div>
    );
}
